import React, { Component } from 'react'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";

import { dangerCardHeader, successCardHeader, purpleCardHeader } from "assets/jss/material-dashboard-pro-react.jsx";

import Api from '../../api/Api.js';
import CommandEndpoints from '../../api/CommandEndpoints';
import { connect } from "react-redux";
import { store } from '../../redux/store';
import { SET_WIN_SERVICES_LIST, SET_WIN_SERVICE_STATUS, SET_REPORT_QUEUE_RUNNING, SET_REPORT_QUEUE_FULL } from '../../redux/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faServer, faSyncAlt, faCode, faBracketsCurly } from '@fortawesome/pro-solid-svg-icons';
import { ServiceStatus } from '../../redux/reducers/DevReducer';
import { cleanReportName } from '../../helpers';
import DevEndpoints from '../../api/DevEndpoints';
import DataTable from '../../components/Table/DataTable';
import { Tooltip, IconButton, ButtonBase } from '@material-ui/core';
import MonacoMySql from 'components/MonacoEditor/MonacoMySql';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "components/CustomButtons/Button.jsx";
//import WinServiceHub from '../../api/WinServiceHub';
//import ReportMonitorHub from '../../api/ReportMonitorHub';

const GetStyle = (status) => {
    switch (status) {
        case ServiceStatus.Stopped:
            return dangerCardHeader;
        case ServiceStatus.Running:
            return successCardHeader;
        default:
            return purpleCardHeader;
    }
}

const GetFriendlyStatus = (status) => {
    switch (status) {
        case "done":
            return "Done";
        case "export_in_progress":
            return "Exporting";
        case "failed_email":
            return "Failed to Email";
        case "failed_export":
            return "Failed to Export";
        case "failed_sftp":
            return "Failed to FTP";
        case "failed_query":
            return "Failed to Query";
        case "failed_unexpectedly":
            return "Failed Unexpectedly";
        case "in_queue":
            return "Queued";
        case "query_in_progress":
            return "Query In Progress";
        case "stopped":
            return "Stopped";
        default:
            return status;
    }
}

class DeveloperDashboard extends Component {

    constructor(props) {
        super (props);
        this.updateQueueState = this.updateQueueState.bind(this);
    }


    state = {
        query: "",
        queryShown: false,
        queryLoading: false
        //winServiceConnection: null
    }

    componentDidMount() {
        Api.get(CommandEndpoints.winServiceList)
            .then(({ data }) => store.dispatch({ type: SET_WIN_SERVICES_LIST, payload: data }))
            .catch((e) => console.error(e));

        Api.get(DevEndpoints.listRunningReports)
            .then(({ data }) => store.dispatch({ type: SET_REPORT_QUEUE_RUNNING, payload: data }))
            .catch((e) => console.error(e));

        Api.get(DevEndpoints.listFullReportQueue)
            .then(({ data }) => store.dispatch({ type: SET_REPORT_QUEUE_FULL, payload: data }))
            .catch((e) => console.error(e));

        var requests = [];
        for (var winService in this.props.winServices.list)
            requests.push(new Promise((resolve, reject) => {
                var current = this.props.winServices.list[winService];
                Api.get(CommandEndpoints.winService, { name: current })
                    .then(({ data }) => {
                        resolve({ name: current, status: data });
                        store.dispatch({ type: SET_WIN_SERVICE_STATUS, name: current, payload: data })
                    })
                    .catch((e) => {
                        console.error(e);
                        reject(e);
                    })
            }));

        this.updateServicesTimer = setTimeout(this.updateServiceState, 3000);
        this.updateQueueTimer = setTimeout(this.updateQueueState, 3000);
        /*
        var winServiceHubConnection = Api.socket(WinServiceHub);
        var reportMonitorHubConnection = Api.socket(ReportMonitorHub);

        this.setState({
            winServiceConnection: winServiceHubConnection,
            reportMonitorConnection: reportMonitorHubConnection
        }, () => {
            //this.state.winServiceConnection.
            this.state.winServiceConnection
                .start()
                .then(() => {
                    console.log('Connection Started - WinService')

                    this.state.winServiceConnection.on('StateChange', (win_service, status) => {
                        store.dispatch({ type: SET_WIN_SERVICE_STATUS, name: win_service, payload: status })
                    });

                })
                .catch(() => console.error('Unable to Connect - WinServiceHub'))

            this.state.reportMonitorConnection
                .start()
                .then(() => {
                    console.log('Connection Started - Report Monitor');
                    this.state.reportMonitorConnection.on('QueueChange', (data) => {
                        console.log(data);
                        store.dispatch({ type: SET_REPORT_QUEUE_RUNNING, payload: data })
                    });
                })
                .catch(() => console.error('Unable to Connect - ReportMonitorHub'))

            //console.log("Connection: ", winServiceHubConnection.connectionState)
        })
        */

        Promise.all(requests).then(() => {
            console.log("Services Set");
        });
    }

    componentWillUnmount() {
        if (this.updateServicesTimer)
            clearTimeout(this.updateServicesTimer);

        if (this.updateQueueTimer)
            clearTimeout(this.updateQueueTimer);

        // if (this.state.winServiceConnection)
        //     this.state.winServiceConnection.stop();
    }

    updateQueueTimer;
    updateQueueState() {
            var running = new Promise((resolve, reject) => {
                Api.get(DevEndpoints.listRunningReports)
                .then(({ data }) => {
                    store.dispatch({ type: SET_REPORT_QUEUE_RUNNING, payload: data });
                    resolve(data)
                })
                .catch((e) => reject(e));
            })
            var full = new Promise((resolve, reject) => {
                Api.get(DevEndpoints.listFullReportQueue)
                .then((response) => {
                    if(response) {
                        store.dispatch({ type: SET_REPORT_QUEUE_FULL, payload: response.data })
                        resolve(response.data)
                    } else {
                        reject(response);
                    }
                })
                .catch((e) => reject(e));
            })

            Promise.all([running, full])
            .finally(() => this.updateQueueTimer = setTimeout(this.updateQueueState, 1000))
    }

    updateServicesTimer;
    updateServiceState = async () => {
        var requests = [];
        for (var winService in this.props.winServices.list)
            requests.push(new Promise((resolve, reject) => {
                var current = this.props.winServices.list[winService];
                Api.get(CommandEndpoints.winService, { name: current })
                    .then(({ data }) => {
                        store.dispatch({ type: SET_WIN_SERVICE_STATUS, name: current, payload: data })
                        resolve({ name: current, status: data });
                    })
                    .catch((e) => {
                        console.error(e);
                        reject(e);
                    })
            }));

        await Promise.all(requests);
        this.updateServicesTimer = setTimeout(this.updateServiceState, 1000);
    }

    retrieveQuery(id) {
        Api.get(DevEndpoints.getQuery, { id })
            .then(({ data }) => {
                this.setState({ queryLoading: false, query: data })
            })
            .catch((e) => {
                this.setState({ queryLoading: false, queryShown: false })
                console.error(e);
            });
    }

    render() {
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                    {
                        this.props.runningReports ?
                            <DataTable
                                title={"Running Reports"}
                                emptyMessage="No Running Reports"
                                data={
                                    this.props.runningReports
                                        .map(
                                            rep => [
                                                rep.report_id,
                                                cleanReportName(rep.report_name),
                                                rep.status === 'export_in_progress'
                                                    ?
                                                    'Export In Progress'
                                                    :
                                                    rep.status === 'in_queue'
                                                        ?
                                                        'Queued'
                                                        :
                                                        'Query In Progress',
                                                <Tooltip key="query" title="View Processed Query">
                                                    <IconButton
                                                        color="secondary"
                                                        onClick={() => {
                                                            console.info(JSON.stringify(rep, null, 4))
                                                            this.setState({ query: '', queryShown: true, queryLoading: true }, () => this.retrieveQuery(rep.id))
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faBracketsCurly} />
                                                    </IconButton>
                                                </Tooltip>
                                            ]
                                        )
                                }
                                columns={runningColumns}
                            />
                            :
                            null
                    }
                    {
                        this.props.fullReportQueue ?
                            <DataTable
                                title={"Report Queue"}
                                emptyMessage="No Historical Reports in Queue"
                                data={
                                    this.props.fullReportQueue
                                        .map(
                                            rep => [
                                                rep.report_id,
                                                cleanReportName(rep.report_name),
                                                GetFriendlyStatus(rep.status),
                                                <Tooltip key="query" title="View Processed Query">
                                                    <IconButton
                                                        color="secondary"
                                                        onClick={() => this.setState({ query: '', queryShown: true, queryLoading: true }, () => this.retrieveQuery(rep.id))}
                                                    >
                                                        <FontAwesomeIcon icon={faBracketsCurly} />
                                                    </IconButton>
                                                </Tooltip>
                                            ]
                                        )
                                }
                                columns={runningColumns}
                            />
                            :
                            null
                    }
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <Card
                        style={{
                            padding: "20px 20px 0 20px"
                        }}
                    >
                        {
                            this.props.winServices.list.map((win_service) => {
                                return (
                                    <ButtonBase
                                        key={win_service}
                                        {
                                        ...(
                                            this.props.winServices.status[win_service] !== ServiceStatus.Running
                                                &&
                                                this.props.winServices.status[win_service] !== ServiceStatus.Stopped
                                                ?
                                                {}
                                                :
                                                { href: "javascript:void(0)" }
                                        )
                                        }
                                        style={{
                                            ...GetStyle(this.props.winServices.status[win_service]),
                                            color: '#fff',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexDirection: 'row',
                                            padding: 20,
                                            borderRadius: 3,
                                            marginBottom: 20
                                        }}
                                        onClick={() => {
                                            if (this.props.winServices.status[win_service] === ServiceStatus.Running) {
                                                //TODO: StopService
                                                store.dispatch({ type: SET_WIN_SERVICE_STATUS, name: win_service, payload: ServiceStatus.StopPending })
                                                Api.get(CommandEndpoints.stopWinService, { name: win_service })
                                            } else if (this.props.winServices.status[win_service] === ServiceStatus.Stopped) {
                                                //TODO: StartService
                                                store.dispatch({ type: SET_WIN_SERVICE_STATUS, name: win_service, payload: ServiceStatus.StartPending })
                                                Api.get(CommandEndpoints.startWinService, { name: win_service });
                                            }
                                        }}
                                    >
                                        <div>
                                            <FontAwesomeIcon icon={faServer} size="3x" />
                                        </div>
                                        <div style={{ flex: 1, paddingLeft: 20, paddingRight: 20, textAlign: 'left' }}>
                                            <span style={{ fontSize: 19, fontWeight: '500' }}>{win_service}</span><br />
                                            <span style={{ fontSize: 17 }}>{this.props.winServices.status[win_service] ? this.props.winServices.status[win_service] : "Loading..."}</span>
                                        </div>
                                        <div>
                                            {
                                                this.props.winServices.status[win_service] !== ServiceStatus.Running
                                                    &&
                                                    this.props.winServices.status[win_service] !== ServiceStatus.Stopped
                                                    ?
                                                    <FontAwesomeIcon icon={faSyncAlt} spin size="3x" />
                                                    :
                                                    <FontAwesomeIcon icon={faPowerOff} size="3x" />
                                            }
                                        </div>
                                    </ButtonBase>
                                );
                            })
                        }
                    </Card>
                </GridItem>
                {
                    /* 
                        Query Dialog
                    */
                }
                <Dialog
                    open={this.state.queryShown}
                    onClose={() => this.setState({ queryShown: false })}
                    fullWidth
                    scroll="paper"
                    maxWidth="lg"
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Processed Query{this.state.queryLoading ? " - Loading..." : ""}</DialogTitle>
                    <DialogContent>
                        <MonacoMySql
                            ref={"monaco_sql"}
                            value={this.state.query}
                            height="600"
                            theme={"vs-dark"}
                            readonly
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button key="cancel" style={{ marginRight: 'auto' }} round onClick={() => this.setState({ queryShown: false })} color="rose" simple>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </GridContainer>
        )
    }
}

const runningColumns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Report Name",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        name: "Status",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: 'Actions',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false
        }
    }
];

const mapStateToProps = (state) => {
    return {
        winServices: state.dev.winServices,
        runningReports: state.dev.runningReports,
        fullReportQueue: state.dev.fullReportQueue
    };
}

export default connect(mapStateToProps)(DeveloperDashboard);